import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  const processSession = useCallback(
    async (sessionId) => {
      try {
        // Send pre-login language preference (set on the public login page) so the
        // backend can save it on the user's account for first-time users.
        let preLoginLang = null;
        try {
          const stored = localStorage.getItem("jobgrid_lang");
          if (stored === "nl" || stored === "en") preLoginLang = stored;
        } catch { /* ignore */ }
        const { data } = await api.post("/auth/session", {
          session_id: sessionId,
          ...(preLoginLang ? { language: preLoginLang } : {}),
        });
        setUser(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/", { replace: true });
      }
    },
    [navigate, setUser]
  );

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    processSession(sessionId);
  }, [navigate, processSession]);

  return (
    <div className="min-h-screen flex items-center justify-center grid-bg" data-testid="auth-callback-loading">
      <div className="brutal-card p-8">
        <p className="label-mono">Authenticating</p>
        <p className="font-heading text-3xl font-black mt-2">Signing you in...</p>
      </div>
    </div>
  );
}
